import React, {useState, useEffect} from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useData } from '../../dataContext';
import * as dbServices from "../../utils/dbServices";
import validator from 'validator';

const CcrMain = (props) => {

    const [registrationInfo, setRegistrationInfo]  = useState({})
    const [msg, setMsg] = useState("")
    const [submitCount, setSubmitCount] = useState(0)
    const {ccrId} = useParams();
    const history = useHistory();
    const { dataAll } = useData();

    //data download & context save here
    useEffect(() => {
        if(dataAll){
            getAddressFromCcrId();
        }
    },[dataAll])

    const getAddressFromCcrId = () =>{

        if (!dataAll) return -1
        
        let temp = dataAll.filter(x=>x["qrCode"]===ccrId)

        if(temp.length>0){
            setRegistrationInfo({...temp[0]})
        }
        
        return -1
    }

    
    const handleFieldChange = (e, k) =>{

        let temp = registrationInfo
        temp[k] = e.target.value
        setRegistrationInfo({...temp})
    }


    const handleSubmit = async() =>{

        const emailCheck = x =>{
            console.log(x)
            if(!x){
                setMsg("Please enter valid email address")
                return 0
            }

            if(!validator.isEmail(x)){
                setMsg("Please enter valid email address")
                return 0
            }

            //regex check

            return 1
        }

        const nameCheck = x =>{

            if(!x){
                setMsg("Please enter valid name")
                return 0
            }

            if(x.length<3){
                 setMsg("Please enter valid name")
                 return 0
            }

            return 1
        }

        const addressCheck = x =>{

            if(!x){
                setMsg("Please enter address")
                return 0
            }

            if(x.length<3) {
                setMsg("Please enter valid address")
                return 0
            }

            return 1
        }
       
        let submitCount = 0

        // valid email address
        if (emailCheck(registrationInfo["email"])==0) return

        // name can't be empty
        if (nameCheck(registrationInfo["name"])==0) return 

        // address can't be empty

        //success

        let temp = submitCount +1
        
        if (temp>3){
            setMsg("Your information has already been submitted.  No further action required.")
        }
        else{
            // restAPI call here
            await dbServices.submitFormData(registrationInfo) 
            history.push('/ccrSubmitSuccess')
        }
    }

    return (
        <div className="container">
            {/* <br style={{height:"10vh"}}/> */}
            
            <h2 style={{fontSize:"4vh", marginTop:"6vh"}}>CS-Chat Sign-Up Page</h2>

            <br/>
            <br/>

            <div className= "row mb-3">
                <div className="col-3">
                    Address
                </div>
                <div className="col-9">
                    <input className="form-control" value={registrationInfo["address"]} onChange={e=>handleFieldChange(e, "address")}>
                    </input>
                </div>
            </div>
            <div className= "row mb-3">
                <div className="col-3">
                    Name
                </div>
                <div className="col-9">
                    <input className="form-control" value={registrationInfo["name"]} onChange={e=>handleFieldChange(e, "name")}>
                    </input>
                </div>
            </div>
            <div className= "row mb-3">
                <div className="col-3">
                    Email
                </div>
                <div className="col-9">
                    <input className="form-control" value={registrationInfo["email"]} onChange={e=>handleFieldChange(e, "email")}>
                    </input>
                </div>
            </div>
            <br/>            
            <div className= "row mb-3">
                <div className="col-12">
                    <button className="form-control btn btn-warning" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
            <br/>
            <br/>
            <div className = "row mb-3">
                <div className="col-8" style={{paddingLeft:"4vw"}}>
                    {msg}
                </div>
            </div>
            
        </div>
    );
}

export default CcrMain;